import { Tooltip } from '@material-ui/core';
import { GraphPickerWithoutMenu } from '../../../../GraphPicker';
import { SubMenuWrapper } from '../EditDefaultsMenu.style';
import { MenuButtonItem } from 'components/MenuButton';
import Icon from 'components/base/Icon';
import { GRAPH_TO_ICON } from '../../../../consts';

const GraphPickerItem = ({ graphType, onGraphTypeChange }) => {
  return (
    <Tooltip
      title={
        <GraphPickerWithoutMenu
          chunks={1}
          selectedGraph={graphType}
          onChange={onGraphTypeChange}
        />
      }
      interactive
      placement='right'
    >
      <SubMenuWrapper>
        <MenuButtonItem
          key='Change type'
          text='Change type'
          icon={
            <Icon
              size='small'
              name={GRAPH_TO_ICON[graphType] ?? GRAPH_TO_ICON.line}
              alpha={0.7}
            />
          }
          onClick={() => {}}
          extraIcon={<Icon size='medium' name='ChevronRight' alpha={0.7} />}
        />
      </SubMenuWrapper>
    </Tooltip>
  );
};

export default GraphPickerItem;
